export const dateFormats = {
  dob: "MM-DD-YYYY",
  dateFormat: "MM-DD-YYYY",
  timeFormat: "hh:mm A",
  dateTimeFormat:"MM-DD-YYYY hh:mm A"
};

export const questionTypeOneConstant = [
  { id: 2, name: "No" },
  { id: 1, name: "Yes" },
];